import { getUrlForLink } from '@/utils/getUrlForLink';
import { useEffect, useRef } from 'react';

interface DirectLink {
  icon: string | null;
  url: string;
  is_direct?: boolean;
}

export const useDirectLink = (directLink?: DirectLink | null) => {
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!hasRedirected.current && directLink?.url) {
      const formattedUrl = getUrlForLink(
        directLink.icon || null,
        directLink.url,
      );
      if (formattedUrl) {
        hasRedirected.current = true;
        if (
          formattedUrl.startsWith('mailto:') ||
          formattedUrl.startsWith('tel:') ||
          formattedUrl.startsWith('sms:')
        ) {
          window.open(formattedUrl, '_self');
        } else {
          window.location.href = formattedUrl;
        }
      }
    }
  }, [directLink]);

  return { hasRedirected: hasRedirected.current };
};
